import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomSelect,
} from '../../../common/components';

const PeiValueEditDialog = ({ open, onClose, onSave, selectedItem, editMode, legalEntity, selectedPlan }) => {
  const [formData, setFormData] = useState({
    uuid_fee: '',
    amount: '',
    rate: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  // Simular lista de fees disponibles
  const mockFees = [
    { uuid: 'fee-1', name: 'Cuota Completa' },
    { uuid: 'fee-2', name: 'Cuota Incompleta' },
    { uuid: 'fee-3', name: 'Adecuacion' },
  ];

  useEffect(() => {
    if (open) {
      setFormData({
        uuid_fee: selectedItem?.fee?.uuid || selectedItem?.uuid_fee || '',
        amount: selectedItem?.amount !== undefined ? selectedItem.amount.toString() : '',
        rate: selectedItem?.rate !== undefined ? selectedItem.rate.toString() : '',
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.uuid_fee) {
      newErrors.uuid_fee = true;
    }
    if (!formData.amount) {
      newErrors.amount = true;
    }
    if (!formData.rate) {
      newErrors.rate = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      // Encontrar el fee seleccionado para incluir su información
      const selectedFee = mockFees.find(fee => fee.uuid === formData.uuid_fee);
      const dataToSave = {
        ...formData,
        fee: selectedFee,
        uuid_legal_entity: legalEntity?.uuid,
        uuid_plan: selectedPlan?.uuid,
      };
      onSave(dataToSave);
    }
  };

  const handleClose = () => {
    setFormData({
      uuid_fee: '',
      amount: '',
      rate: '',
    });
    setErrors({});
    setSaveAttempted(false);
    onClose();
  };

  return (
    <DialogContainer open={open} onClose={handleClose} size="medium">
      <DialogTitle>
        {editMode ? 'Editar valores PEI' : 'Agregar valores PEI'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <CustomSelect
            margin="dense"
            name="uuid_fee"
            label="Tipo de Cuota"
            fullWidth
            value={formData.uuid_fee}
            onChange={handleSelectChange}
            error={errors.uuid_fee || (saveAttempted && !formData.uuid_fee)}
            helperText={
              errors.uuid_fee || (saveAttempted && !formData.uuid_fee) 
                ? 'Debes seleccionar un tipo de cuota.' 
                : ''
            }
            options={mockFees.map(fee => ({
              value: fee.uuid,
              label: fee.name
            }))}
          />

          <CustomTextField
            margin="dense"
            name="amount"
            label="Monto"
            type="number"
            fullWidth
            value={formData.amount}
            onChange={handleInputChange}
            error={errors.amount || (saveAttempted && !formData.amount)}
            helperText={
              errors.amount || (saveAttempted && !formData.amount) 
                ? 'Debes ingresar un monto.' 
                : ''
            }
          />

          <CustomTextField
            margin="dense"
            name="rate"
            label="Porcentaje"
            type="number"
            fullWidth
            value={formData.rate}
            onChange={handleInputChange}
            error={errors.rate || (saveAttempted && !formData.rate)}
            helperText={
              errors.rate || (saveAttempted && !formData.rate) 
                ? 'Debes ingresar un porcentaje.' 
                : ''
            }
          />
        </Box>
      </DialogBody>

      <DialogActions handleClose={handleClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default PeiValueEditDialog;
